import {
  Button as PButton,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  useDisclosure,
} from '@chakra-ui/react';
import { FileErrorIcon } from '@sketchnote/icons';
import { Button, LoaderXs } from '@sketchnote/shared-components';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useFileService } from 'src/features/files/api/useFileServices';

type FileButtonProps = {
  filename?: string;
  file?: any;
  fileLink: string;
  isPublicDoc?: boolean;
};

export const FileButton = ({ filename, file, fileLink, isPublicDoc }: FileButtonProps) => {
  const { onOpen, onClose, isOpen } = useDisclosure();
  const [isLoadingPublicToggle, setPublicToggleLoader] = useState<boolean>(false);
  const [isFilePublic, setIsFilePublic] = useState<boolean>(true);
  // const isFileAvailable = file && !!file.status;
  const isFileDeleted = file && file.status === 'deleted';
  const isFileUnavailableForPublicView = file?._id && !isFilePublic;
  const { togglePublicView } = useFileService();

  useEffect(() => {
    setIsFilePublic(file.isPublic);
  }, [file.isPublic]);

  const onClickMakePublic = async () => {
    setPublicToggleLoader(true);
    if (file) {
      const result = await togglePublicView(file._id, true);
      setPublicToggleLoader(false);
      if (result?.data.success) {
        if (result.data.data.isPublic) setIsFilePublic(true);
      }
    }
  };

  return (
    <div className="flex">
      <a
        contentEditable={false}
        className={classNames(
          ' underline text-primary-600 hover:text-primary-400 transition-all flex items-center',
          {
            'line-through': isFileDeleted || (!file?._id && isPublicDoc),
            'pointer-events-none': !file?._id && isPublicDoc,
          }
        )}
        title={isFileDeleted ? 'File Deleted' : filename}
        href={fileLink}
      >
        <span>{filename || 'Untitled'}</span>
      </a>
      {isFileUnavailableForPublicView && (
        <span title="File unavailable" className="relative">
          <Popover placement="right" isOpen={isOpen} onOpen={onOpen} onClose={onClose}>
            <PopoverTrigger>
              <PButton>
                <FileErrorIcon className="ml-4" stroke="#F4381F" size={18} />
              </PButton>
            </PopoverTrigger>
            <PopoverContent>
              <PopoverBody contentEditable={false}>
                <div className="relative">
                  {isLoadingPublicToggle && (
                    <div className="w-full h-full bg-gray-800 opacity-75 flex justify-center items-center absolute rounded-sm">
                      <LoaderXs />
                    </div>
                  )}
                  <div className=" bg-gray-800 p-12 rounded-sm text-white w-296">
                    <div className="mb-8">
                      <span className="font-medium">This is a private file</span>
                      <p className="text-xs">
                        Enable public access on this file so all members viewing the Wiki can access
                        this file too
                      </p>
                    </div>
                    <div>
                      <Button onClick={onClickMakePublic} size="sm" className="mr-12">
                        Make it public
                      </Button>
                      <button className="text-sm" onClick={onClose}>
                        Ignore
                      </button>
                    </div>
                  </div>
                </div>
              </PopoverBody>
            </PopoverContent>
          </Popover>
        </span>
      )}
    </div>
  );
};
